import React from 'react';

import WalletCashIcon from '@/assets/icons/wallet-cash';
import WalletGoldIcon from '@/assets/icons/wallet-gold';
import { useHasSocialWallet } from '@/hooks/use-has-social-wallet';
import { SocialCurrency, useSocialCurrencyStore } from '@/hooks/use-social-currency';

export const SocialCurrencyActiveIcon = ({ size = 16 }: { size?: number }) => {
    const hasSocialWallet = useHasSocialWallet();
    const activeCurrency = useSocialCurrencyStore(state => state.activeCurrency);
    if (!hasSocialWallet) {
        return null;
    }
    if (activeCurrency === SocialCurrency.CASH) {
        return <WalletCashIcon size={size} />;
    }
    if (activeCurrency === SocialCurrency.COINS) {
        return <WalletGoldIcon size={size} />;
    }
    return null;
};
